import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownRightIcon, MessageCircleIcon, SmartphoneIcon, SparklesIcon } from 'lucide-react';
import { HERO_BANNER_URL } from '../lib/constants';
import { CtaButton } from './CtaButton';
export function Hero() {
  return <section id="top" className="w-full overflow-hidden bg-warm" data-id="element-78" data-mp="9igvb8esxojn">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 pb-16 pt-11 sm:px-8 sm:pb-24 lg:grid-cols-[0.95fr_1.05fr] lg:items-center lg:gap-14 lg:pb-28 lg:pt-16" data-id="element-79" data-mp="4na1csbc3y7x">
        <div className="relative z-10 max-w-2xl" data-id="element-80" data-mp="x9umvc54pg3k">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.45
        }} className="inline-flex items-center gap-2 rounded-full bg-lime px-3.5 py-2 text-[0.7rem] font-extrabold uppercase tracking-[0.12em] text-ink" data-id="element-81" data-mp="x8b8xs6y3h4y">
            <SparklesIcon className="h-4 w-4" data-id="element-82" data-mp="382ff5o82r4ex" />
            Webs que hacen que te elijan
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 22
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.06,
          ease: [0.22, 1, 0.36, 1]
        }} className="mt-6 font-display text-[3.45rem] font-extrabold leading-[0.89] text-ink sm:text-7xl lg:text-[5.45rem]" data-id="element-83" data-mp="3j8sezzr63hpb">
            Tu negocio merece una web que se sienta{' '}
            <span className="inline-block bg-coral px-2 text-white" data-id="element-84" data-mp="30i18r72h87f5">imposible</span> de ignorar.
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.15
        }} className="mt-7 max-w-xl text-base leading-relaxed text-slate-700 sm:text-lg" data-id="element-85" data-mp="3599i633t3ssb">
            Soy Maggie. Diseño páginas con color, carácter y estrategia para que tu marca no se vea
            como una más.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.23
        }} className="mt-8 flex flex-col items-start gap-4 sm:flex-row sm:items-center" data-id="element-86" data-mp="2ll0gn2gdiag5">
            <CtaButton icon={<MessageCircleIcon className="h-5 w-5" data-id="element-88" data-mp="ibozao1l0svy" />} data-id="element-87" data-mp="ic87ve5ce4xb">Quiero mi web</CtaButton>
            <a href="#estilos" className="inline-flex items-center gap-1.5 text-sm font-extrabold text-ink transition-colors hover:text-brand-600" data-id="element-89" data-mp="dd5cymj2tf32">
              Mira los estilos
              <ArrowDownRightIcon className="h-4 w-4" data-id="element-90" data-mp="1ayt8743sprd0" />
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.45,
          delay: 0.36
        }} className="mt-8 flex flex-wrap gap-x-5 gap-y-2 text-sm font-bold text-slate-600" data-id="element-91" data-mp="162m47guympxp">
            <span data-id="element-92" data-mp="3lt73mli5bhrm">Diseño pensado para ti</span>
            <span className="hidden text-coral sm:inline" data-id="element-93" data-mp="3lquftrppid6n">●</span>
            <span data-id="element-94" data-mp="3hqkamh9qnqsu">Comunicación directa</span>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96,
        rotate: 1
      }} animate={{
        opacity: 1,
        scale: 1,
        rotate: 0
      }} transition={{
        duration: 0.7,
        delay: 0.1,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative" data-id="element-95" data-mp="1xa431cdmkgik">
          <div className="absolute -left-5 top-8 h-36 w-36 bg-coral sm:-left-9 sm:h-48 sm:w-48" aria-hidden data-id="element-96" data-mp="2686aoarv67et" />
          <div className="absolute -bottom-5 right-8 h-28 w-28 rounded-full bg-lime sm:-bottom-8 sm:right-16 sm:h-40 sm:w-40" aria-hidden data-id="element-97" data-mp="2fzsuuwm6jgtp" />
          <img src={HERO_BANNER_URL} alt="Collage de diseños web creativos y coloridos en ventanas de navegador" className="relative z-10 aspect-[4/3] w-full border-[5px] border-ink object-cover shadow-[10px_10px_0_#12131A]" data-id="element-98" data-mp="2kxudjgfp1e4n" />
          <div className="absolute -bottom-5 left-4 z-20 flex items-center gap-2 bg-white px-4 py-3 shadow-[5px_5px_0_#2444F5] sm:bottom-7 sm:-left-5" data-id="element-99" data-mp="umpt0a2ni12p">
            <SmartphoneIcon className="h-5 w-5 text-brand-500" data-id="element-100" data-mp="zlsx9sat439m" />
            <span className="text-sm font-extrabold tracking-[-0.02em] text-ink" data-id="element-101" data-mp="4akwoxpqsifg">Hecha para celular</span>
          </div>
          <div className="absolute right-3 top-4 z-20 hidden items-center gap-2 bg-lime px-3.5 py-2.5 sm:flex" data-id="element-102" data-mp="3vh5lsbw8lg9u">
            <SparklesIcon className="h-4 w-4" data-id="element-103" data-mp="e8scvec7iwge" />
            <span className="text-xs font-extrabold uppercase tracking-[0.08em] text-ink" data-id="element-104" data-mp="99xmnrbwu5m9">Diseño + estrategia</span>
          </div>
        </motion.div>
      </div>
    </section>;
}